import { useAppDispatch } from "../../../redux/useAppDispatch";
import PlayButtton from "../../SharedComponent/ActionButtons/PlayButtton";
import InfoButton from "../../SharedComponent/ActionButtons/InfoButton";
import DeleteButton from "../../SharedComponent/ActionButtons/DeleteButton";
import DownloadButton from "../../SharedComponent/ActionButtons/DownloadButton";
import { getDownloadPackdetails, openDownloadModal } from "../../../redux/Transcribe/TranscribeAction";
import React from "react";

interface ActionColumnProps {
  record: any;
}

function ActionColumn({ record }: ActionColumnProps) {
  const dispatch = useAppDispatch();

  return (
    <div className="d-flex gap-2 w-100 justify-content-center">
      {record.status === "ARCHIVED" && (
        <>
          {record.isExportResultAvailable === 1 ? (
            <DownloadButton
              onClick={() => {
                dispatch(getDownloadPackdetails(record.packId));
                dispatch(openDownloadModal());
              }}
            />
          ) : (
            <span>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp;</span>
          )}
          <PlayButtton
            disabled={false}
            record={record}
          />
          <InfoButton disabled={true} />
          <DeleteButton disabled={true} />
        </>
      )}
    </div>
  );
}

export default React.memo(ActionColumn);
